import { useState, useEffect, useCallback } from "react";
import RepositoryFactory from "../../../../../../../repositories/RepositoryFactory";

export const useGetPOItems = (poId, user, lang, refresh, defaultPageSize = 10) => {
  const PurchaseOrderClient = RepositoryFactory.get("PurchaseOrder");
  const [search, setSearch] = useState("");
  const [poItems, setPoItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(1);

  const changePageSize = (size) => {
    setPageSize(size);
    setPage(1);
  };

  const handleChangePage = (activePage) => {
    setPage(activePage);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handleUpdateStatus = async (POId, POItemsId, Status) => {
    try {
      await PurchaseOrderClient.updatePOItemStatus({
        POItemsId,
        Status,
        Lang: lang,
        POId,
        UserId: user,
      });
      await getPOItems();
    } catch (error) {
      console.log("error on handleUpdateStatus", error);
    }
  };

  const handleExpand = useCallback(
    (index, value) => {
      const newPoItems = [...poItems];
      newPoItems[index].expanded = value || !newPoItems[index].expanded;
      setPoItems(newPoItems);
    },
    [poItems]
  );

  const handleEditItem = (index, value) => {
    const newPoItems = [...poItems];
    newPoItems[index].edit = value;
    setPoItems(newPoItems);
  };

  const updatePOItem = async (item) => {
    try {
      const body = {
        ...item,
        UserId: user,
      };
      setLoading(true);
      await PurchaseOrderClient.updatePOItem(body);
      getPOItems();
    } catch (error) {
      console.log("error", error);
      throw new Error('error al actualizar item');
    } finally {
      setLoading(false);
    }
  };

  const parcedPOItem = async (POItemsId) => {
    try {
      setLoading(true);
      await PurchaseOrderClient.parcedPOItems({
        POId: poId,
        POItemsId,
        UserId: user,
      });
      getPOItems();
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const massiveUpdate = async (values) => {
    try {
      const body = {
        ...values,
        UserId: user,
      };
      setLoading(true);
      await PurchaseOrderClient.massivePOItemsUpdate(body);
      getPOItems();
    } catch (_error) {
      throw new Error('error al actualizar item');
    } finally {
      setLoading(false);
    }
  };

  const getPOItems = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      if (!poId) return;
      const body = {
        lang: lang || 'MX',
        user,
        search,
        page,
        pageSize,
      }
      const response = await PurchaseOrderClient.getPOItems(poId, body);
      let poItems = response.data;
      setTotalPages(Math.ceil((response.total || 1) / pageSize) || 1);
      poItems.map((item) => {
        item.expanded = false;
        item.edit = false;
        return item;
      })
      setPoItems(poItems);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setError(error);
      setLoading(false);
    }
  }, [poId, user, lang, page, pageSize, search]);

  useEffect(() => {
    getPOItems();
  }, [poId, getPOItems, refresh]);

  return {
    poItems,
    loading,
    error,
    handleExpand,
    handleEditItem,
    updatePOItem,
    handleSearch,
    handleUpdateStatus,
    massiveUpdate,
    parcedPOItem,
    changePageSize,
    handleChangePage,
    page,
    pageSize,
    totalPages,
  };
};
